import { $f } from "@shared/hooks/shared/formatter";
import cn from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";

interface IProps {
  isSmall?: boolean;
  isColumn?: boolean;
  user: {
    balanceBet: number;
    balanceWin: number;
    currency: string;
  };
}
export const Sweepstakes: React.FC<IProps> = ({
  isSmall = false,
  isColumn = false,
  user,
}) => {
  if (!user) {
    return null;
  }

  const { balanceBet: entries, balanceWin: totalWin } = user ?? {};

  return (
    <div
      className={cn("sweepstakes", {
        "sweepstakes--small": isSmall,
        "sweepstakes--column": isColumn,
      })}
    >
      <div className="sweepstakes__item">
        <div className="sweepstakes__title">
          <FormattedMessage id="boilerplate.Components.Sweepstakes.Entries" />
        </div>
        <div className="sweepstakes__value">
          {$f.formatMoney($f.toMoney(entries))}
        </div>
      </div>
      <div className="sweepstakes__item">
        <div className="sweepstakes__title">
          <FormattedMessage id="boilerplate.components.Sweepstakes.TotalWin" />{" "}
          ({user.currency})
        </div>
        <div className="sweepstakes__value">
          {$f.formatMoney($f.toMoney(totalWin))}
        </div>
      </div>
    </div>
  );
};
